export default __webpack_public_path__ + "static/media/diamond.d24a290a.png";